// src/App.tsx
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useEffect } from "react";
import { MsalProvider } from "@azure/msal-react";

import { useBoundStore } from "Zustand/store/mainStore";
import Projects from "Pages/Projects/Projects";
import AuthRoute from "Components/AuthRoute";
import ProjectDetail from "Pages/ProjectDetail/ProjectDetail";
import "./App.css";
import UsersPage from "Pages/UserManagement/UserManagement";
import TestReportsPage from "Pages/TestReports/TestReportDetail";
import TestSpecificationDetail from "Pages/TestSpecificationDetail/TestSpecificationDetail";
import AuthResponseOidc from "Pages/AuthResponseOidc/AuthResponseOidc";

const App = ({ instance }) => {
  const { restoreAuth } = useBoundStore();

  useEffect(() => {
    restoreAuth();
  }, [restoreAuth]);

  return (
    <MsalProvider instance={instance}>
      <Router>
        <Routes>
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="/auth/response-oidc" element={<AuthResponseOidc />} />
          <Route element={<AuthRoute instance={instance} />}>
            <Route path="/" element={<></>} />{" "}
            {/* will show Login or redirect */}
            <Route path="/projects" element={<Projects />} />
            <Route path="/admin/users" element={<UsersPage />} />
            <Route path="/project-detail" element={<ProjectDetail />} />
            <Route
              path="/testspecification-detail"
              element={<TestSpecificationDetail />}
            />
            <Route path="/report-detail" element={<TestReportsPage />} />
          </Route>
        </Routes>
      </Router>
    </MsalProvider>
  );
};

export default App;